import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IConsultarCpfState } from './types';

export const INITIAL_STATE: IConsultarCpfState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IConsultarCpfState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_CPF_REQUEST: {
				break;
			}
			case Types.CONSULTAR_CPF_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTAR_CPF_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTAR_CPF_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
